import { Component, Element, Prop, State } from '@stencil/core';

import { ContainerSize } from '../../../interfaces';

@Component({
  tag: 'width-observer',
  styleUrl: 'width-observer.css',
  shadow: false,
})
export class WidthObserver {
  @Element() el: HTMLElement;
  @Prop() renderer: (size: ContainerSize) => any;
  @Prop() minSizes = {
    '5xs': 253,
    '4xs': 323,
    '3xs': 350,
    xs: 530,
    sm: 640,
    md: 768,
    lg: 1024,
    xl: 1280,
    '2xl': 1536,
  };
  @State() size: ContainerSize;
  observer: ResizeObserver;

  connectedCallback() {
    this.observer = new ResizeObserver((entries) => this.onResize(entries));
    this.observer.observe(this.el);
  }

  disconnectedCallback() {
    this.observer.disconnect();
  }

  render() {
    if (this.size) {
      return this.renderer(this.size);
    }
  }

  onResize(entries: ResizeObserverEntry[]) {
    const entry = entries[0];
    if (entry) {
      const contentBoxSize = Array.isArray(entry.contentBoxSize) ? entry.contentBoxSize[0] : entry.contentBoxSize;
      const size = contentBoxSize.inlineSize;
      this.size = {
        width: size,
        breakpoints: {
          '5xs': size >= this.minSizes['5xs'],
          '4xs': size >= this.minSizes['4xs'],
          '3xs': size >= this.minSizes['3xs'],
          xxs: size < this.minSizes.xs,
          xs: size >= this.minSizes.xs,
          sm: size >= this.minSizes.sm,
          md: size >= this.minSizes.md,
          lg: size >= this.minSizes.lg,
          xl: size >= this.minSizes.xl,
          '2xl': size >= this.minSizes['2xl'],
        },
      };
    }
  }
}
